import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import StoreExpenseAddInvoiceForm from "./StoreExpenseAddInvoiceForm";
import StoreExpense, { newStoreExpense } from "../../models/store-expense";

interface StoreExpenseUpdateModalProps {
  show: boolean;
  storeExpense?: StoreExpense;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const StoreExpenseAddInvoiceModal: React.FC<StoreExpenseUpdateModalProps> = ({
  show,
  storeExpense,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialStoreExpense, setInitialStoreExpense] = useState<StoreExpense>(
    storeExpense ? storeExpense : newStoreExpense()
  );

  const modalTitle = storeExpense
    ? `Añadir o modificar Datos de factura: ${storeExpense.description}`
    : `Añadir Datos de factura nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialStoreExpense(newStoreExpense());
    onCancel();
  };
  useEffect(() => {
    setInitialStoreExpense(storeExpense ? storeExpense : newStoreExpense());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeExpense]);

  return (
    <CModal show={show} onClose={onClose} size="xl" color="success">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <StoreExpenseAddInvoiceForm
            initialStoreExpense={initialStoreExpense}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default StoreExpenseAddInvoiceModal;
